import { getHttpClient } from '../../api/axiosInstance'
import { useQuery } from '@tanstack/react-query'

const initStorage = async () => {
  const apiClient = getHttpClient()

  const response = await apiClient.get('/common/file-manager/v1/storage')

  return response.data
}

export const key = 'common.storage'

export const useStorage = () => {
  return useQuery({
    queryKey: [key],
    queryFn: initStorage,
    refetchOnWindowFocus: false,
    staleTime: 60 * (60 * 1000), // 60 minutes
    cacheTime: 60 * (60 * 1000) // 60 minutes
  })
}

export const isStorageAvailable = (data) => data?.enabled && data?.mode === 'radix'
export const isOldStorageAvailable = (data) => data?.enabled && data?.mode === 'box'
